import "./auth.client.types";

import {
  genericOAuthClient,
  inferAdditionalFields,
  organizationClient,
  twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { UserType } from "@elation/api-client/src/stitch-web/models/userType";

import { IS_CAPACITOR, IS_CHROME_EXTENSION, SERVICE_URL } from "@src/env";

import { BEARER_TOKEN_KEY } from "./auth.constants";
import {
  clearTwoFactorChallengeTokens,
  getAuthClientFetchOptions,
  usesBearerAuth,
} from "./auth.transport";

export {
  clearTwoFactorChallengeTokens,
  getBearerAuthHeaders,
  getBearerAuthToken,
  usesBearerAuth,
} from "./auth.transport";

export const authClient = createAuthClient({
  // Capacitor serves the bundle from a local scheme (capacitor://localhost,
  // https://localhost), so window.location.origin isn't the real API host.
  baseURL:
    IS_CHROME_EXTENSION || IS_CAPACITOR
      ? SERVICE_URL
      : `${window.location.origin}/api/auth`,
  fetchOptions: getAuthClientFetchOptions(),
  plugins: [
    genericOAuthClient(),
    organizationClient(),
    // Deliberately configured without `twoFactorPage`/`onTwoFactorRedirect`:
    // both would have to redirect from module scope, and `twoFactorPage` does it
    // with a full page reload, which breaks the extension/Capacitor memory
    // routers. The login flow reads `twoFactorRedirect` off the sign-in result
    // and navigates through React Router instead.
    twoFactorClient(),
    inferAdditionalFields({
      user: {
        type: {
          type: Object.values(UserType),
          required: true,
        },
      },
    }),
  ],
});

export type Session = typeof authClient.$Infer.Session;

export async function signOut() {
  try {
    return await authClient.signOut();
  } finally {
    if (usesBearerAuth()) {
      localStorage.removeItem(BEARER_TOKEN_KEY);
      clearTwoFactorChallengeTokens();
    }
  }
}
